<template>
  <div>
    <template v-if="$route.name == 'secretKey'">
      <ots-main-title></ots-main-title>
      <ots-table-group-new
        :selectList="selectList"
        :requestForm="requestForm"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        @changeNum="changeNum"
        @changePage="changePage"
        @search="search"
      ></ots-table-group-new>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>
<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getPlanPlaceListAPI, queryEnterKeyListAPI, exportEnterKeyDetailAPI } from "@/http/modules/computedRoomExam";
import {
  getPlanAllSessionByPlan,
} from "@/http/modules/examSet/planClass";
export default {
  data() {
    return {
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '考点名称',
          type: 'select',
          requestKey: 'placeId',
          label: 'name',
          value: 'id',
          data: [],
        },
        {
          title: '场次',
          type: 'select',
          requestKey: 'sessionId',
          label: 'name',
          value: 'id',
          data: [],
        },
      ],
      pagination: {
        total: 0,
      },
      tableData: [],
      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "考点名称",
          prop: "placeName",
        },
        {
          title: "场次",
          prop: "sessionName"
        },
        {
          title: "教室",
          prop: "className",
        },
        {
          title:"机房进场秘钥",
          type:"buttons",
          width:"160",
          btnList:[
            { title:"查看", click: this.showSheet},
            { title:"下载", click: this.downLoad},
          ]
        }
      ],
      requestForm: {
        planId: '',
        placeId: '',
        sessionId: '',
        size: 10,
        page: 1,
      },
    }
  },
  watch: {
    'requestForm.planId': function(value) {
      this.getPlace(value);
      this.getChainSession();
      this.getTableData();
    },
  },
  created() {
    this.getPlan();
  },
  methods: {
    // 查询
    search() {
      this.requestForm.page = 1;
      this.getTableData();
    },

    // 获取批次
    async getPlan() {
      const { data: planData } = await getSelectPlanFn({needAudit: 8});
      this.selectList[0].data = planData;
      this.requestForm.planId = planData[0].id;
    },

    // 获取考点
    async getPlace(value) {
      const { data: placeData } = await getPlanPlaceListAPI({planId: value});
      if (!placeData) {
        this.selectList[1].data = [];
        this.requestForm.placeId = '';
        return;
      }
      this.selectList[1].data = [{id: '', name: '全部'}, ...placeData];
      this.requestForm.placeId = "";
    },

    // 获取场次
    async getChainSession() {
      let params = {
        planId: this.requestForm.planId,
      };
      const { code, data } = await getPlanAllSessionByPlan(params);
      if (code == 1) {
        let sessionId = [{ id: "", name: "全部" }, ...data];
        this.$set(this.selectList[2], "data", sessionId);
      } else {
        this.requestForm.sessionId = ''
        this.$set(this.selectList[2], "data", [{ id: "", name: "全部" }]);
      }
    },

    // 获取表格数据
    async getTableData() {
      let params = { ...this.requestForm };
      const { code, data } = await queryEnterKeyListAPI(params);
      if (code == 1) {
        this.tableData = data.records;
        this.pagination.total = data.total;
      }
    },

    // 查看
    showSheet(row) {
      let params = {...row, planId: this.requestForm.planId}
      window.localStorage.setItem('lookSecretKey',JSON.stringify(params))
      this.$router.push({
        name:'secretKeyLook',
      })
    },

    // 下载
    async downLoad(row) {
      let params = {
        placeId: row.placeId,
        planId: this.requestForm.planId,
        sessionId: row.sessionId,
      }

      const {code, data} = await exportEnterKeyDetailAPI(params);
      if (code == 1) {
        window.open(data.address);
      }
    },

    changeNum(num) {
      this.requestForm.size = num
      this.getTableData()
    },

    changePage(p) {
      this.requestForm.page = p;
      this.getTableData();
    },
  }

}
</script>